























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import ContextMenu from "@/components/buttons/context-menu.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import { IAudioFTP } from "@/@types/audio/audio";
import { audio } from "@/config/host.config";

@Component({ components: { ContextMenu, BSwitch, ChangeDeliteButtons } })
export default class FsDirectorys extends Vue {
  @Prop({ type: Array, default: () => [] }) items!: Array<IAudioFTP>;
  @Prop({ type: String, default: "" }) path!: string;

  constxtID = "";
  song: HTMLAudioElement | null = null;
  songSRC = "";
  $refs!: {
    menu: ContextMenu;
  };

  updateItem(id: string, type: boolean): void {
    if (!type) this.$emit("deleteFile", id);
    else {
      const update = this.items.find((el) => el.path == id);
      if (update) this.$emit("updateFile", update);
    }
  }

  handler(e: PointerEvent, name: string | undefined): void {
    e.preventDefault();
    if (!name) return;
    this.$nextTick(() => {
      this.$refs.menu.contextX = e.clientX;
      this.$refs.menu.contextY = e.clientY;
      this.$refs.menu.showContext = true;
      this.constxtID = name;
    });
  }

  playFile(path: string): void {
    this.songSRC = path;
    const marker = `${audio.songsSRCFs}?path=${path}`;
    const token = this.$store.getters.getAccess;
    const src = `${marker}&Authorization=${`Bearer ${token}`}`;
    this.song = new Audio(src);
    this.song.play();
  }

  @Watch("path")
  stop(): void {
    this.songSRC = "";
    if (!this.song) return;
    this.song.pause();
    this.song = null;
  }

  destroyed(): void {
    this.stop();
  }
}
